import React, { useEffect } from 'react';
import moment from 'jalali-moment';
import grassIcon2 from '../../assets/grass-2.svg';
import pomegranateIcon from '../../assets/pomegranate-2.svg';
import music from '../../assets/audio/fasle-bahar.mp3';

import './style';

const newYearDate = moment('1399-12-30 13:07:28', 'YYYY-MM-DD HH:mm:ss');

const DEG = 6;

const hr = React.createRef<HTMLDivElement>();
const mn = React.createRef<HTMLDivElement>();
const sc = React.createRef<HTMLDivElement>();
const timer = React.createRef<HTMLDivElement>();
const audio = React.createRef<HTMLAudioElement>();
const msg = React.createRef<HTMLDivElement>();;
const msg2 = React.createRef<HTMLDivElement>();;

const TRANSITION_NONE = 'none';
const TRANSITION_ACTIVE = 'ease-in-out 0.2s';

const setCountdown = () => {
  const now = new Date().getTime();
  const timeleft = newYearDate.toDate().getTime() - now;
  let days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
  let hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

  if (newYearDate.isBefore(now)) {
    days = hours = minutes = seconds = 0;
    msg.current.innerText = 'سال ۱۴۰۰ بر شما مبارک باد :)';
    msg2.current.innerText = '';
  }

  timer.current.innerHTML = `
    <div class="countdown row ltr" style="line-height: 1.7">
      <div class="col-3 countdown-num">${days}</div>
      <div class="col-3 countdown-num">${hours}</div>
      <div class="col-3 countdown-num">${minutes}</div>
      <div class="col-3 countdown-num">${seconds}</div>
      <div class="col-3">روز</div>
      <div class="col-3">ساعت</div>
      <div class="col-3">دقیقه</div>
      <div class="col-3">ثانیه</div>
    </div>
  `;
}

const setClockTime = () => {
  const day = new Date();
  const hh = day.getHours() * 30;
  const mm = day.getMinutes() * DEG;
  const ss = day.getSeconds() * DEG;

  if (ss === 59 * DEG) {
    sc.current.style.transition = TRANSITION_NONE;
  }
  if (ss === DEG) {
    sc.current.style.transition = TRANSITION_ACTIVE;
  }

  if (mm === 59 * DEG) {
    mn.current.style.transition = TRANSITION_NONE;
  }
  if (mm === DEG) {
    mn.current.style.transition = TRANSITION_ACTIVE;
  }

  hr.current.style.transform = `rotateZ(${hh + (mm / 12)}deg)`;
  mn.current.style.transform = `rotateZ(${(mm)}deg)`;
  sc.current.style.transform = `rotateZ(${(ss)}deg)`;
}

const handlePlayClicked = async (e: React.MouseEvent<HTMLDivElement>) => {
  const parent = e.currentTarget.parentElement;
  await audio.current.play();
  parent.remove();
}

const Nowruz = () => {

  useEffect(() => {
    setClockTime();
    setCountdown();
    setInterval(() => {
      setClockTime();
      setCountdown();
    }, 1000);
  });

  return (
    <div className="nowruz-component">
      <div className="card mb-5 px-3 pb-2">
        <img src={'/logo.png'} alt="" style={{ width: '50px', margin: '10px auto 0 auto' }} />
        شرکت دارستان صنعت نیکان، <br />
        سالی سرشار از خوشی و سلامتی برای شما آرزو میکند
      </div>
      <div className="clock">
        <div className="hour">
          <div className="hr" ref={hr}></div>
        </div>
        <div className="min">
          <div className="mn" ref={mn}></div>
        </div>
        <div className="sec">
          <div className="sc" ref={sc}></div>
        </div>
        <div className="clock-back">
          <img src={grassIcon2} className="left" alt="" />
          <img src={grassIcon2} className="right" alt="" />
        </div>
      </div>
      <div className="row w-100 mt-4">
        <div className="col-xxl-5 col-xl-6 col-md-7 col-12 mx-auto">
          <div className="card">
            <div className="card-body">
              <div ref={msg}>لحظه‌ی تحویل سال ۱۴۰۰ ساعت ۱۳:۰۷:۲۸</div>
              <div ref={msg2}>روز شنبه ۳۰ اسفند سال ۱۳۹۹ می‌باشد</div>
              <div className="ltr" ref={timer}></div>
              <div className="row rtl mt-3">
                <div className="col-12">
                  اي برگ قوت يافتي تا شاخ را بشکافتي<br />
                چون رستي از زندان بگو تا ما در اين حبس آن کنيم
                </div>
              </div>
            </div>
            <img className="annar annar-left" src={pomegranateIcon} alt="" />
            {/* <img className="annar annar-right" src={pomegranateIcon2} alt=""/> */}
            {/* <img className="grass" src={pomegranateIcon2} alt=""/> */}
          </div>
        </div>
      </div>
      <audio src={music} loop ref={audio}></audio>
      <div className="overlay-play">
        <span className="play-btn" onClick={handlePlayClicked}>
          <i className="fas fa-play"></i>
        </span>
      </div>
    </div>
  );
}

export default Nowruz;
